import { render, staticRenderFns } from "./DataMobileTable.vue?vue&type=template&id=3532afc2&scoped=true&"
import script from "./DataMobileTable.vue?vue&type=script&lang=js&"
export * from "./DataMobileTable.vue?vue&type=script&lang=js&"
import style0 from "./DataMobileTable.vue?vue&type=style&index=0&id=3532afc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532afc2",
  null
  
)

export default component.exports